import * as yup from 'yup';

// Helm release name validation pattern - follows Kubernetes DNS label standards
const HELM_RELEASE_NAME_REGEX = /^[a-z0-9]([a-z0-9-]{0,51}[a-z0-9])?$/;

export const helmInstallFormValidationSchema = yup.object().shape({
  useGitOps: yup.boolean().required(),
  namespace: yup.string().required('Namespace is required'),
  name: yup
    .string()
    .required('Release name is required')
    .max(53, 'Release name must be 53 characters or less')
    .matches(
      HELM_RELEASE_NAME_REGEX,
      "Release name must consist of lowercase alphanumeric characters or '-', start and end with an alphanumeric character (e.g. 'my-app', 'web-server')"
    ),
  SourceId: yup.number().when('useGitOps', {
    is: true,
    then: yup.number().required('Source is required'),
    otherwise: yup.number().optional(),
  }),
  RepositoryURL: yup.string(),
  RepositoryURLValid: yup.boolean(),
  HelmChartPath: yup.string(),
  HelmValuesFiles: yup
    .array(yup.string().required('Path is required'))
    .default([]),
  RepositoryReferenceName: yup.string(),

  // Auto update fields
  AutoUpdate: yup.object().shape({
    RepositoryAutomaticUpdates: yup.boolean().default(false),
    RepositoryMechanism: yup
      .string()
      .oneOf(['Webhook', 'Interval'])
      .default('Interval'),
    RepositoryFetchInterval: yup.string().default('5m'),
    ForcePullImage: yup.boolean().default(false),
    RepositoryAutomaticUpdatesForce: yup.boolean().default(false),
  }),
  webhookId: yup.string(),

  // Manual install fields - required when useGitOps is false
  version: yup.string().when('useGitOps', {
    is: false,
    then: yup.string().required('Version is required'),
    otherwise: yup.string(),
  }),
  values: yup.string(),
  repo: yup.string(),
  registryId: yup.number(),
  chartName: yup.string(),
  chartRepo: yup.string(),
});
